var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginaTerugIcoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.372,
    height: 21.104,
    viewBox: "0 0 22.372 21.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pagina_terug_Icoon",
    "data-name": "Pagina terug Icoon",
    transform: "translate(-955.463 -674.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-back",
    "data-name": "Icon ionic-md-arrow-round-back",
    d: "M26.058,14.847H12.453L17.73,9.8a2.1,2.1,0,0,0,0-2.874,1.88,1.88,0,0,0-2.746,0L6.2,15.445a1.936,1.936,0,0,0-.572,1.424v.025A1.936,1.936,0,0,0,6.2,18.319l8.78,8.519a1.88,1.88,0,0,0,2.746,0,2.1,2.1,0,0,0,0-2.874l-5.277-5.048H26.052A1.99,1.99,0,0,0,28,16.882,1.969,1.969,0,0,0,26.058,14.847Z",
    fill: "#BEBEBE",
    transform: "translate(949.838 667.788)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginaTerugIcoon);
export default __webpack_public_path__ + "static/media/Pagina_terug_Icoon.8a31439e.svg";
export { ForwardRef as ReactComponent };